export const calculateLaborCost = ({
  hours,
  hourlyRate,
  payType,
  commissionRate,
  jobRevenue,
}) => {
  if (payType === "commission") {
    return (Number(jobRevenue || 0) * Number(commissionRate || 0)) / 100;
  }

  return Number(hours || 0) * Number(hourlyRate || 0);
};
